"use strict";

// Convierte las condiciones viejas (reportDinamicEmail) al formato de acciones.
// La misma transformación se usa al abrir el editor y al importar un formulario.
function conditionsToActions(reportConfig) {
    if (!reportConfig || reportConfig.reportDinamicEmailCopied === true) {
        return [];
    }
    if (!Array.isArray(reportConfig.reportDinamicEmail) || reportConfig.reportDinamicEmail.length === 0) {
        return [];
    }

    return reportConfig.reportDinamicEmail.map(function (condition, i) {
        let startCondition = "";
        if (condition.itemValidate || condition.itemValidate === "") {
            switch (condition.itemValidate) {
                case "":
                    startCondition = "validate";
                    break;
                case "OK":
                    startCondition = "validate_ok";
                    break;
                case "REJECT":
                    startCondition = "validate_reject";
                    break;
            }
        } else {
            startCondition = "new_record";
        }

        return {
            name: "Condición N° " + (i + 1),
            description: "Sin descripción",
            start: startCondition,
            reportDinamicCondition: [condition],
            action: "email",
            openConditions: false,
            openAction: false,
            inactive: false,
            actionData: {
                subject: "",
                body: "",
                report: "pdf_attachment",
                options: condition.options,
            },
        };
    });
}

function applyLegacyConditions(reportConfig) {
    const actions = conditionsToActions(reportConfig);
    if (!actions.length) {
        return reportConfig;
    }
    if (!Array.isArray(reportConfig.actions)) {
        reportConfig.actions = [];
    }
    actions.forEach(function (action) {
        reportConfig.actions.push(action);
    });
    reportConfig.reportDinamicEmailCopied = true;
    return reportConfig;
}

module.exports = {
    conditionsToActions: conditionsToActions,
    applyLegacyConditions: applyLegacyConditions,
};
